import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { CookieModule } from '@laurentgoudet/ngx-cookie';
import { environment } from '../../environments/environment';
import { WHITELIST_COOKIE } from './abtest.config';
import { ABTest } from './abtest.service';

@NgModule({
  imports: [HttpClientModule, TrackingModule, CookieModule],
})
export class ABTestModule {
  static initialize(): ModuleWithProviders {
    return {
      ngModule: ABTestModule,
      providers: [
        ABTest,
        { provide: WHITELIST_COOKIE, useValue: environment.whitelistCookie },
      ],
    };
  }
}
